/* ============================================================
   Culture Motorsports - Phase 1 runtime
   - Branded loader
   - Guarded background video in the hero AND in extra zones
     (drop section, The Build lane, founder block)
   - CTA micro-interactions
   Zero markup edits in the homepage section: this script
   upgrades the existing DOM in place and reads config from
   window.CM_PHASE1 (emitted by the cm-phase1 section).
   Guardrails: reduced-motion, Save-Data, slow connections and
   any load/autoplay failure all fall back to the static image.
   Video is lazy-loaded only when its zone nears the viewport.
   ============================================================ */
(function () {
  'use strict';
  var doc = document;
  var cfg = window.CM_PHASE1 || {};
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || navigator.webkitConnection || {};
  var saveData = !!conn.saveData;
  var slow = /(^|-)(2g|slow-2g)$/.test(conn.effectiveType || '');
  var blockVideo = reduce || saveData || slow;
  var isMobile = window.matchMedia && matchMedia('(max-width: 767px)').matches;

  /* ---------- Branded loader ---------- */
  function dismissLoader() {
    var l = doc.getElementById('cmLoader');
    var x = doc.querySelector('.cmx');
    if (x) x.classList.add('cm-hero-go');
    if (!l || l.classList.contains('cm-done')) return;
    l.classList.add('cm-done');
    setTimeout(function () { if (l && l.parentNode) l.parentNode.removeChild(l); }, 700);
  }
  if (doc.readyState === 'complete') { setTimeout(dismissLoader, 200); }
  else { window.addEventListener('load', function () { setTimeout(dismissLoader, 250); }); }
  setTimeout(dismissLoader, 1600);

  /* ---------- Shared: lazy, guarded video attach ---------- */
  function attachVideo(scope, video, src, readyEl, fallback) {
    var started = false;
    function start() {
      if (started) return; started = true;
      video.src = src;
      video.load();
      video.addEventListener('canplay', function () {
        var p = video.play();
        if (p && p.then) {
          p.then(function () { readyEl.classList.add(scope === 'hero' ? 'cm-video-ready' : 'cm-zone-ready'); })
           .catch(function () {});
        } else { readyEl.classList.add(scope === 'hero' ? 'cm-video-ready' : 'cm-zone-ready'); }
      }, { once: true });
      video.addEventListener('error', function () { if (fallback) fallback(); }, { once: true });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } });
      }, { rootMargin: '300px' });
      io.observe(readyEl);
    } else { start(); }
    doc.addEventListener('visibilitychange', function () {
      if (!started) return;
      if (doc.hidden) video.pause();
      else if (readyEl.classList.contains(scope === 'hero' ? 'cm-video-ready' : 'cm-zone-ready')) video.play().catch(function () {});
    });
  }

  function makeVideo(poster) {
    var v = doc.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'none'); v.setAttribute('aria-hidden', 'true');
    if (poster) v.setAttribute('poster', poster);
    return v;
  }
  function pick(z) { return (isMobile ? (z.videoMobile || z.video) : (z.video || z.videoMobile)) || ''; }

  /* ---------- Hero ---------- */
  function initHero() {
    var hero = doc.querySelector('.cmx .chero');
    if (!hero) return;
    hero.setAttribute('data-cm-hero', '');
    var fallback = cfg.fallback || 'poster';
    if (!hero.querySelector('.cm-scroll')) {
      var cue = doc.createElement('div');
      cue.className = 'cm-scroll';
      cue.innerHTML = '<span>Scroll</span><i></i>';
      hero.appendChild(cue);
    }
    var posterImg = hero.querySelector('img.bg');
    var poster = cfg.poster || (posterImg ? posterImg.getAttribute('src') : '');
    var src = isMobile ? (cfg.videoMobile || cfg.video) : (cfg.video || cfg.videoMobile);
    var wantVideo = cfg.show !== false && !!src;
    if (blockVideo || !wantVideo) {
      if (fallback === 'black') addStatic(hero);
      return;
    }
    var video = makeVideo(poster);
    video.className = 'bg cm-hero-video';
    hero.insertBefore(video, hero.firstChild);
    attachVideo('hero', video, src, hero, function () { if (fallback === 'black') addStatic(hero); });
  }

  function addStatic(hero) {
    if (hero.querySelector('.cm-hero-static')) { hero.classList.add('cm-static'); return; }
    var s = doc.createElement('div');
    s.className = 'cm-hero-static';
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML = '<span class="cm-hero-static-word">Culture</span>';
    hero.insertBefore(s, hero.firstChild);
    hero.classList.add('cm-static');
  }

  /* ---------- Extra zones ---------- */
  function initZone(sel, z) {
    if (!z || !z.video || blockVideo) return;
    var el = doc.querySelector(sel);
    if (!el) return;
    var src = pick(z);
    if (!src) return;
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    var img = el.querySelector('img');
    var poster = z.poster || (img ? img.getAttribute('src') : '');
    var video = makeVideo(poster);
    video.className = 'cm-zone-video';
    if (img && img.parentNode === el) img.insertAdjacentElement('afterend', video);
    else el.insertBefore(video, el.firstChild);
    attachVideo('zone', video, src, el, null);
  }

  function initZones() {
    var z = cfg.zones || {};
    initZone('.cmx .drop', z.drop);
    // The Build lane = the lane linking to /pages/the-build (fallback: 2nd lane)
    var buildSel = '.cmx .lanes .lane[href*="the-build"]';
    if (!doc.querySelector(buildSel)) buildSel = '.cmx .lanes .lane:nth-of-type(2)';
    initZone(buildSel, z.build);
    initZone('.cmx .founder .media', z.founder);
  }

  /* ---------- Magnetic CTA buttons ---------- */
  function initMagnetic() {
    if (reduce || 'ontouchstart' in window) return;
    doc.querySelectorAll('.cmx .chero .btn').forEach(function (b) {
      b.classList.add('cm-mag');
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var mx = e.clientX - r.left - r.width / 2;
        var my = e.clientY - r.top - r.height / 2;
        b.style.transform = 'translate(' + (mx * 0.18) + 'px,' + (my * 0.28 - 2) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  function ready(fn) {
    if (doc.readyState !== 'loading') fn();
    else doc.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { initHero(); initZones(); initMagnetic(); });
})();
